import type { FilterCardLayout } from "../types/filter";

export const splitIntoColumns = <T>(items: readonly T[], columnCount = 2): readonly T[][] => {
    const columns: T[][] = Array.from({ length: columnCount }, () => []);

    for (let i = 0; i < items.length; i++) {
        columns[i % columnCount].push(items[i]);
    }

    return columns;
};

type WithCardLayout = { filterCardLayout?: FilterCardLayout };

export const partitionByCardLayout = <T extends WithCardLayout>(
    items: readonly T[],
): { fullWidthItems: T[]; gridItems: T[] } => {
    const fullWidthItems: T[] = [];
    const gridItems: T[] = [];

    for (const item of items) {
        if (item.filterCardLayout === "full-width") {
            fullWidthItems.push(item);
        } else {
            gridItems.push(item);
        }
    }

    return { fullWidthItems, gridItems };
};
